@if (highlightedField(); as field) {
  @if (field.location === FieldLocation.GeneralTab) {
  <div class="approval-action-banner">
    <mat-icon>notifications_active</mat-icon>
    <span>
      <strong>Action Required:</strong>
      Waiting for {{ field.role }}
    </span>
  </div>
  } @else if (field.location === FieldLocation.Both) {
  <div class="approval-action-banner">
    <mat-icon>notifications_active</mat-icon>
    <span>
      <strong>Action Required:</strong>
      See {{ field.role }}
    </span>
  </div>
  }
  @else {
  <div class="approval-action-banner">
    <mat-icon>info</mat-icon>
    <span>
      <strong>Action Required:</strong>
      Waiting for {{ field.role }} <em>(See Approval flow Tab)</em>
    </span>
  </div>
  }
  }
